<template>
  <v-dialog v-model="model" max-width="640" scrollable>
    <v-card>
      <v-card-title>{{ $t("supplier_requests.title") }}</v-card-title>
      <v-card-text class="pt-2">
        <v-progress-linear v-if="loading" indeterminate />
        <div v-else-if="!requests.length" class="text-center grey--text py-8">{{ $t("supplier_requests.empty") }}</div>
        <v-list v-else two-line>
          <v-list-item v-for="r in requests" :key="r.id">
            <v-list-item-content>
              <v-list-item-title>{{ r.name }} · {{ r.supplier_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ r.email }}<span v-if="r.phone"> · {{ r.phone }}</span></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="flex-row">
              <v-btn small text color="error" :disabled="busy === r.id" @click="reject(r)">{{ $t("supplier_requests.reject") }}</v-btn>
              <v-btn small color="primary" depressed :disabled="busy === r.id" @click="approve(r)">{{ $t("supplier_requests.approve") }}</v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <p v-if="requests.length" class="caption grey--text mt-2 mb-0">{{ $t("supplier_requests.hint") }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="model = false">{{ $t("close") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import supplierAccountRequestService from "@/services/supplierAccountRequest";

/** Zahtjevi dobavljaca za nalog: odobri (pravi nalog i šalje mejl) ili odbij. */
export default {
  name: "SupplierAccountRequestsDialog",
  mixins: [hasModel, hasSnackbar],
  data: () => ({ requests: [], loading: false, busy: null }),
  watch: {
    model(val) {
      if (val) this.load();
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.requests = (await supplierAccountRequestService.list()).data;
      } catch (e) {
        this.showErrorSnackbar(this.$t("error"));
      } finally {
        this.loading = false;
      }
    },
    async approve(r) {
      await this.act(r, () => supplierAccountRequestService.approve(r.id), (data) =>
        this.$t(data.mailed ? "supplier_requests.approved" : "supplier_requests.approved_no_mail")
      );
    },
    async reject(r) {
      await this.act(r, () => supplierAccountRequestService.reject(r.id), () => this.$t("supplier_requests.rejected"));
    },
    async act(r, call, message) {
      this.busy = r.id;
      try {
        const { data } = await call();
        this.requests = this.requests.filter((x) => x.id !== r.id);
        this.showSuccessSnackbar(message(data));
        this.$emit("changed", this.requests.length);
      } catch (e) {
        const data = e.response && e.response.data;
        const first = data && data.errors && Object.values(data.errors)[0];
        this.showErrorSnackbar((first && first[0]) || (data && data.message) || this.$t("error"));
      } finally {
        this.busy = null;
      }
    },
  },
};
</script>
